import { render, staticRenderFns } from "./MembersCard.vue?vue&type=template&id=0bb995e3&"
import script from "./MembersCard.vue?vue&type=script&lang=js&"
export * from "./MembersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports